module.exports = __webpack_public_path__ + "static/img/6.8aa0baf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/eng/6.png
// module id = 7GhN
// module chunks = 0